import React from 'react';

const Footer = () => (
  <footer className="bg-[#ffe7c7] text-black text-center py-4">
    <p>© {new Date().getFullYear()} All rights reserved. Built with 💻 DinikDelavega.</p>
  </footer>
);

export default Footer;
